export const permissions = {
  EXTERNAL_NAME_CHANGE: 'agent_aftersales_external.nameChange',
  INTERNAL_NAME_CHANGE: 'agent_aftersales_contract.nameChange',
  EXTERNAL_WAIVE_FEES: 'agent_aftersales_external.waiveFees',
  INTERNAL_WAIVE_FEES: 'agent_aftersales_contract.waiveFees',
  INTERNAL_OVERRIDE_AFTERSALES_RULES: 'agent_aftersales_contract.overrideAftersalesRules',
  EXTERNAL_OVERRIDE_AFTERSALES_RULES: 'agent_aftersales_external.overrideAftersalesRules'
};

export const MOBILE_TERMINAL_ID_STORAGE_KEY = 'MOBILE_TERMINAL_ID_STORAGE_KEY';
export const MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY = 'MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY';

export const AGENT_ROLE_VOYAGER_GROUP = 'VOYAGER_GROUP';
